import React from 'react';
import {BaseProps} from "../../../../infrastructure/models/props/base-props";
import {CompetitorPlayersStatsModulePlayerViewModel} from "../../models/competitor-players-stats-module.player.view-model";
import {CompetitorPlayersStatsModulePlayerStatsTopStatsContent} from "./competitor-players-stats-module.player-stats.top-stats.content";
import styles from "../../styles/competitor-players-stats-module.module.scss";
import classNames from "classnames";
import {CardTitleWrapper} from "../../../../core/components/misc/card-tite/card-title.wrapper";

export class CompetitorPlayersStatsModulePlayerStatsTopStatsProps extends BaseProps {
  player: CompetitorPlayersStatsModulePlayerViewModel
  topStatsTitle: String;
  topStatsIconSize: Number;
  isSmallView: Boolean;
}

export const CompetitorPlayersStatsModulePlayerStatsTopStats = ({player, topStatsIconSize, topStatsTitle, isSmallView}: CompetitorPlayersStatsModulePlayerStatsTopStatsProps) => {
  const contentProps = {
    player,
    topStatsIconSize,
    isSmallView
  }

  return (
    <CardTitleWrapper title={topStatsTitle} className={classNames(styles.player_stats_top_stats_container)}>
      <CompetitorPlayersStatsModulePlayerStatsTopStatsContent {...contentProps}/>
    </CardTitleWrapper>
  )
}
